import { authHeader, config } from '../_helpers';

export const createProfileService = {
  getAll,
  createProfile,
  getAllGISS,
  getAllResource,
};

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(config.apiUrl + '/api/getlistprofile', requestOptions).then(
    handleResponse,
    handleError,
  );
}

function getAllGISS() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(
    config.apiUrl + '/api/getlistprofile?giss_only=true',
    requestOptions,
  ).then(handleResponse, handleError);
}

function getAllResource() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(
    config.apiUrl + '/api/getlistprofile?all=true',
    requestOptions,
  ).then(handleResponse, handleError);
}

function createProfile(data) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: data,
  };

  return fetch(config.apiUrl + '/api/register', requestOptions).then(
    handleResponse,
    handleError,
  );
}

function handleResponse(response) {
  return new Promise((resolve, reject) => {
    if (response.ok) {
      // return json if it was returned in the response
      const contentType = response.headers.get('content-type');
      if (contentType?.includes('application/json')) {
        response.json().then((json) => resolve(json));
      } else {
        resolve();
      }
    } else {
      // return error message from response body
      response.text().then((text) => reject(text));
    }
  });
}

function handleError(error) {
  return Promise.reject(error?.message);
}
